import { render, staticRenderFns } from "./Upazila.vue?vue&type=template&id=1a374bd2"
import script from "./Upazila.vue?vue&type=script&lang=js"
export * from "./Upazila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports